import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "fileName", "fileSizeError"]
  static values = { maxFileSize: Number }

  connect() {
    // Hide the native file input
    if (this.hasInputTarget) {
      this.inputTarget.classList.add("hidden")
    }
  }

  triggerFileInput(event) {
    event.preventDefault()
    if (this.hasInputTarget) {
      this.inputTarget.click()
    }
  }

  handleFileChange(event) {
    const file = event.target.files[0]

    if (!file) {
      return
    }

    if (file.size > this.maxFileSizeValue) {
      event.target.value = ""
      this.fileNameTarget.textContent = "Choose image to upload"
      this.fileSizeErrorTarget.classList.remove("hidden")
      this.buttonTarget.setAttribute("aria-invalid", "true")
      return
    }

    this.fileNameTarget.textContent = file.name
    this.fileSizeErrorTarget.classList.add("hidden")
    this.buttonTarget.removeAttribute("aria-invalid")
  }
}
